<template>
<section>
  <div class="list-group-item mb-2" :style="`background-color: ${backgroundColor}`">
    <form id="requirement-details-maintenance">
      <div style="display: grid; grid-template-rows: repeat(1, 1fr); grid-template-columns: repeat(10, 1fr); grid-column-gap: 0.75rem;">
        <b-form-group label="Line Number" >
            <b-form-input v-model.number="line.lineNum" type="number" min="0"></b-form-input>
        </b-form-group>
        <b-form-group label="Qty" >
          <b-form-input v-model.number="line[reqFields.QUANTITY]" type="number"
            :class="{ 'is-invalid': $v.line[reqFields.QUANTITY].$error }" @blur="$v.line[reqFields.QUANTITY].$touch()" ></b-form-input>
          <div class="invalid-feedback">
            <div v-if="!$v.line[reqFields.QUANTITY].required">Quantity is required</div>
          </div>
        </b-form-group>
        <b-form-group label="Max Qty"  v-if="showMaxQty">
          <b-form-input v-model.number="line.maxQuantity" disabled></b-form-input>
        </b-form-group>
        <b-form-group label="Cost"  v-if="!onPurchase">
          <b-input-group :prepend="'$'" size="sm">
            <b-form-input :value="formatMoney(line[reqFields.COST], 4)" type="number" readonly :disabled="!!requirementLine[reqFields.REQUIREMENT_ID]"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group :label="onPurchase ? 'Cost' : 'Price'">
          <b-input-group :prepend="line.currencySymbol ? line.currencySymbol : '$'" size="sm">
            <b-form-input v-model.number="line[reqFields.PRICE]" :style="line[reqFields.PRICE] < line[reqFields.COST] ? 'border-color: #cc0000' : 'border-color: #fd7e14'"
            :class="{ 'is-invalid': $v.line[reqFields.PRICE].$error }" @blur="$v.line[reqFields.PRICE].$touch()" type="number" min="0"></b-form-input>
          </b-input-group>
          <div class="invalid-feedback">
            <div v-if="!$v.line[reqFields.PRICE].required">Price is required</div>
          </div>
        </b-form-group>
        <b-form-group label="Currency" >
          <b-form-select v-model="header[reqFields.CURRENCY_TYPE_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(currOpt) in sortSelect(currencies)" :key="currOpt.id" :value="currOpt.id">{{currOpt.name}}
              </option>
            </b-form-select>
          <!-- <lookup-dropdown label="currency" moduleName="currencies" resource="currency" propKey="currencyTypeId"
              :value="header[reqFields.CURRENCY_TYPE_ID]" :options="currencies" @change="onValueChangeHeader"
              :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" /> -->
        </b-form-group>
        <b-form-group label="Exchange Rate" >
          <b-form-input type="number" v-model.number="header[reqFields.EXCHANGE_RATE]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
        </b-form-group>
        <b-form-group :label="`Converted ${ onPurchase ? 'Cost' : 'Price'}`" >
          <b-input-group prepend="$" size="sm">
            <b-form-input :value="formatMoney(line.convertedPrice, 4)" readonly :disabled="!!requirementLine[reqFields.REQUIREMENT_ID]"></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Line Total" >
          <b-input-group :prepend="line.currencySymbol ? line.currencySymbol : '$'" size="sm">
            <b-form-input :value="formatMoney(lineTotal, 4)" readonly :disabled="!!requirementLine[reqFields.REQUIREMENT_ID]"></b-form-input>
          </b-input-group>
        </b-form-group>
        <!-- <b-form-group label="Lead Time"  v-if="!invoiceView">
          <lookup-dropdown label="warranty" moduleName="warranty" resource="inventoryWarranty" propKey="inventoryWarrantyId"
            :value="part[reqFields.LEAD_TIME]" :options="manufacturers" @change="onValueChangePart"
            :dropdownDisabled="!editableLeadTime" />
        </b-form-group> -->
      </div>
    </form>
  </div>
  <div class="list-group-item" :style="`background-color: ${backgroundColor}`">
    <form id="requirement-details-maintenance">
      <div style="display: grid; grid-template-rows: repeat(4, 1fr); grid-template-columns: repeat(12, 1fr); grid-column-gap: 0.75rem;">
        <b-form-group label="Part #" style="grid-column: 1/3;">
           <b-input-group size="sm">
              <b-input-group-append>
                <b-button variant="light" @click="$bvModal.show('part-maintenance-model')" :disabled="havePart">
                  <i v-show="this.part.id == undefined || this.part.id == null || this.part.id == 0" class="part-lookup--plus fa fa-plus"></i>
                  <i v-show="this.part.id > 0" class="part-lookup--plus fa fa-pencil"></i>
                </b-button>
              </b-input-group-append>
              <!-- <vue-simple-suggest
                class="suggest-input form-control"
                :styles="autoCompleteStyle"
                :list="getList"
                v-model="chosenPartNumber"
                :max-suggestions="20"
                :min-length="2"
                :debounce="750"
                :filter-by-query="true"
                value-attribute="id"
                display-attribute="partNumber"
                @select="onSuggestSelect"
                @input="onSuggestChange"
                :class="{ 'is-invalid': ($v.chosenPartNumber.$error && requirementLine[reqFields.REQUIREMENT_ID] === 0 ) }"
                @blur="onPartNumberBlur"
                @request-done="onRequestDone"
                >
                <div slot="misc-item-below" v-if="isLoadingPart" class="misc-item">
                  <span>Loading Part...</span>
                </div>
              </vue-simple-suggest> -->
              <b-form-input v-model="chosenPartNumber" disabled />
            </b-input-group>
            <div class="invalid-feedback">
              <div v-if="!$v.chosenPartNumber.required && requirementLine[reqFields.REQUIREMENT_ID] === 0">Part Number is required</div>
            </div>
          <!-- <b-form-input v-model="chosenPartNumber" disabled /> -->
        </b-form-group>

        <b-form-group :label="`${onPurchase ? 'Vendor' : 'Customer'} PN`" style="grid-column: 1/3;" class="mt-1">
          <b-form-input v-model="line[reqFields.CUSTOMER_PN]"></b-form-input>
        </b-form-group>

        <b-form-group label="Alternate PN" style="grid-column: 1/3;" class="mt-1">
          <b-form-input v-model="part[reqFields.ALT_NUMBER]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
        </b-form-group>
        <b-form-group label="NSN" style="grid-column: 1/3;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.NSN_NUMBER]"></b-form-input>
        </b-form-group>
        <b-form-group label="Harmonized Code" style="grid-column: 1/3;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.HARMONIZED_CODE]"></b-form-input>
        </b-form-group>
        <b-form-group label="Schedule B" style="grid-row: 5; grid-column: 3/5;" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.SCHEDULE_B]"></b-form-input>
        </b-form-group>
        <b-form-group label="ECCN" style="grid-row: 5; grid-column: 5/7" class="mt-1">
          <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.ECCN]"></b-form-input>
        </b-form-group>
        <b-form-group label="Item Comments" v-if="onPurchase" :style="`grid-row: 5; grid-column: 7/10`">
          <b-form-input v-model="line[reqFields.COMMENTS]"></b-form-input>
        </b-form-group>
          <b-form-group label="Mfr" style="grid-row: 1; grid-column: 3/5;" >
            <b-form-select v-model="part[reqFields.MANUFACTURER_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(mfrOpt) in sortSelect(manufacturers)" :key="mfrOpt.id" :value="mfrOpt.id">{{mfrOpt.name}}
              </option>
            </b-form-select>
            <!-- <lookup-dropdown label="Manufacturer" moduleName="mfrs" resource="inventoryManufacturer" propKey="inventorymanufacturerId"
              :value="part[reqFields.MANUFACTURER_ID]" :options="manufacturers" @change="onValueChangePart" :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" /> -->
          </b-form-group>

          <b-form-group label="Class" style="grid-row: 1; grid-column: 5/7;" >
            <b-form-select v-model="part[reqFields.INVENTORY_CLASS_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(classOpt) in sortSelect(classes)" :key="classOpt.id" :value="classOpt.id">{{classOpt.name}}
              </option>
            </b-form-select>
            <!-- <lookup-dropdown label="class" moduleName="classes" resource="inventoryClass" propKey="inventoryclassId"
              :value="part[reqFields.INVENTORY_CLASS_ID]" :options="classes" @change="onValueChangePart" :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" /> -->
          </b-form-group>
          <b-form-group label="Description" style="grid-row: 1; grid-column: 7/10" >
            <b-form-input v-model="part[reqFields.DESCRIPTION]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>

          <b-form-group label="Part Comments" style="grid-row: 1; grid-column: 10/13" >
            <b-form-input :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" v-model="part[reqFields.PART_COMMENTS]"></b-form-input>
          </b-form-group>
          <b-form-group label="Category" style="grid-row: 2; grid-column: 3/5;" >
            <b-form-select v-model="part[reqFields.INVENTORY_CATEGORY_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(category) in sortSelect(categories)" :key="category.id" :value="category.id">{{category.name}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Package" style="grid-row: 2; grid-column: 5;" >
            <b-form-select v-model="part[reqFields.PACKAGE_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(packagingOpt) in sortSelect(packaging)" :key="packagingOpt.id" :value="packagingOpt.id">{{packagingOpt.name}}
              </option>
            </b-form-select>
            <!-- <lookup-dropdown label="packaging" moduleName="packaging" resource="inventoryPackaging"
              propKey="packageId" :value="part[reqFields.PACKAGE_ID]" :options="packaging" @change="onValueChangePart"
              :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected" /> -->
          </b-form-group>
          <b-form-group label="SPQ" style="grid-row: 2; grid-column: 6;" >
            <b-form-input type="number" v-model="part[reqFields.SPQ]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>
          <b-form-group label="MOQ" style="grid-row: 2; grid-column: 7;" >
            <b-form-input type="number" v-model="line[reqFields.MOQ]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>
          <b-form-group label="Physical Package" style="grid-row: 2; grid-column: 8;">
            <b-form-input v-model="part[reqFields.PHYS_PKG]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>
          <b-form-group label="UOM" style="grid-row: 2; grid-column: 9;">
            <b-form-select v-model="part[reqFields.UOM_ID]" :disabled="addSources || !!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" size="sm">
              <option v-for="(uomOpt) in sortSelect(uoms)" :key="uomOpt.id" :value="uomOpt.id">{{uomOpt.name}}
              </option>
            </b-form-select>
            <!-- <lookup-dropdown label="UOM" moduleName="uoms" resource="inventoryUom"
              propKey="uoMId" :value="part[reqFields.UOM_ID]" :options="uoms" @change="onValueChangePart"
              :dropdownDisabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected" /> -->
          </b-form-group>
          <b-form-group label="Temp" style="grid-row: 2; grid-column: 10;">
            <b-form-input v-model="part[reqFields.TEMP_RATING]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber"></b-form-input>
          </b-form-group>
          <b-form-group label="RoHS" style="grid-row: 2; grid-column: 11/13;" >
            <b-form-select v-model="part[reqFields.LEAD_FREE]" :disabled="!!requirementLine[reqFields.REQUIREMENT_ID] || partNumberSelected || isByPartNumber" id="leadFree" size="sm">
              <option v-for="(value) in leadFreeValues" v-bind:key="value" v-bind:value="value">{{value}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Date Code" style="grid-row: 3; grid-column: 3;" class="required">
            <b-form-input v-model="line[reqFields.DATE_CODE]" :class="{ 'is-invalid': $v.line[reqFields.DATE_CODE].$error }" @blur="$v.line[reqFields.DATE_CODE].$touch()"></b-form-input>
            <!-- <div class="invalid-feedback">
              <div v-if="!$v.line[reqFields.DATE_CODE].required">Date Code is required</div>
            </div> -->
          </b-form-group>
          <b-form-group label="Lot" style="grid-row: 3; grid-column: 4;" >
            <b-form-input v-model="line[reqFields.LOT_CODE]"></b-form-input>
          </b-form-group>
          <b-form-group label="Revision" style="grid-row: 3; grid-column: 5;" >
            <b-form-input v-model="line[reqFields.REVISION]"></b-form-input>
          </b-form-group>
          <b-form-group label="Condition" style="grid-row: 3; grid-column: 6/8;" >
            <lookup-dropdown label="condition" moduleName="conditions" resource="inventoryCondition"
              propKey="conditionId" :value="line[reqFields.CONDITION_ID]" :options="conditions" @change="onValueChangeLine" />
          </b-form-group>
          <b-form-group label="COO" style="grid-row: 3; grid-column: 8/10;">
            <b-form-select v-model="line.countryOfOriginId">
              <option value="0"> </option>
              <option
                  v-for="(countryCode) in sortSelect(countryCodes)"
                  v-bind:key="countryCode.id"
                  v-bind:value="countryCode.id"
                >{{countryCode.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Needs By" v-if="!invoiceLineView" style="grid-row: 3; grid-column: 10;" >
            <date-picker v-model="line[reqFields.NEED_BY_DATE]" :config="datePickerOptions"></date-picker>
          </b-form-group>
          <b-form-group label="Testing"  v-if="!invoiceLineView" style="grid-row: 3; grid-column: 11;" >
            <b-form-select v-model="line[reqFields.TESTING_REQUESTED]">
              <option v-for="(select, index) in sortSelect(testings)" :key="index" :value="select.value">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <!-- <b-form-group label="Ship Via" style="grid-row: 4; grid-column: 3/5;" class="required">
            <b-form-select v-model="line[reqFields.SHIPPING_METHOD_ID]" :class="{ 'is-invalid': $v.line[reqFields.SHIPPING_METHOD_ID].$error }" @blur="$v.line[reqFields.SHIPPING_METHOD_ID].$touch()">
              <option v-for="(select, index) in sortSelect(shipViaList)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group> -->
          <b-form-group label="In Stock" style="grid-row: 4; grid-column:3;" class="mr-2" v-if="onPurchase">
            <b-form-select v-model="line.isInStock" >
                <option :value="null"> </option>
                <option v-for="(select, index) in sortSelect(testings)" :key="index" :value="select.value">{{ select.name }}</option>
              </b-form-select>
          </b-form-group>
          <b-form-group label="Trace Info" style="grid-row: 4; grid-column: 4/11" v-if="onPurchase">
            <b-form-checkbox v-model="line.isFullLabelTraceable" inline>Full label, traceable</b-form-checkbox>
            <b-form-checkbox v-model="line.isLotCodeRemoved" inline>Lot Code removed</b-form-checkbox>
            <b-form-checkbox v-model="line.isMfrCocPackList" inline>MFR COC/Pack List</b-form-checkbox>
            <b-form-checkbox v-model="line.isFranchiseCocPackList" inline>Franchise COC/Pack List</b-form-checkbox>
            <b-form-checkbox v-model="line.isNotTraceable" inline>Not traceable</b-form-checkbox>
          </b-form-group>
          <b-form-group label="Vendor Warranty" :style="`grid-row: 4; grid-column: ${onPurchase ? '10' : '3'};`">
            <b-form-select v-model="line[reqFields.VENDOR_WARRANTY_ID]" :disabled="!onPurchase">
              <option v-for="(select, index) in sortSelect(warranty)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Cust Warranty" style="grid-row: 4; grid-column: 4;" v-if="!onPurchase" :class="isRequiredWarrantyLeadTime ? 'required' : ''">
            <b-form-select v-model="line[reqFields.WARRANTY_ID]" :class="{ 'is-invalid': $v.line[reqFields.WARRANTY_ID].$error }" @blur="$v.line[reqFields.WARRANTY_ID].$touch()">
              <option v-for="(select, index) in sortSelect(warranty)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Vendor Lead Time" v-if="!invoiceLineView" :style="`grid-row: 4; grid-column: ${onPurchase ? '11' : '5'};`">
            <b-form-input v-model="line[reqFields.VENDOR_DELIVERY]" :disabled="!onPurchase"></b-form-input>
          </b-form-group>
          <b-form-group label="Cust Lead Time" style="grid-row: 4; grid-column: 6;" v-if="!onPurchase && !invoiceLineView" :class="isRequiredWarrantyLeadTime ? 'required' : ''">
            <b-form-input v-model="line[reqFields.CUSTOMER_DELIVERY]" :class="{ 'is-invalid': $v.line[reqFields.CUSTOMER_DELIVERY].$error }" @blur="$v.line[reqFields.CUSTOMER_DELIVERY].$touch()"></b-form-input>
          </b-form-group>
          
          <b-form-group label="Item Comments" v-if="!onPurchase" :style="`grid-row: 4; grid-column: ${ invoiceLineView ? '5/8' : '7/10'};`">
            <b-form-input v-model="line[reqFields.COMMENTS]"></b-form-input>
          </b-form-group>
          <!-- <b-form-group label="Vendor Note" style="grid-row: 6; grid-column: 3/5;" >
            <b-form-input v-model="line[reqFields.VENDOR_NOTE]"></b-form-input>
          </b-form-group> -->

          <b-modal id="part-maintenance-model" ref="partMaintenanceModel" ok-title="Save" scrollable hide-footer>
            <part-form :partId="partId" :partNumberProp="chosenPartNumber" @cancel="onPartModelClose" @partCreated="onPartCreated" @partUpdated="onPartUpdated" />
          </b-modal>
      </div>
     </form>
  </div>
</section>
</template>

<script>
/****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************
*****************************************************************************************************/

import { mapState, mapGetters, mapActions } from 'vuex';
import VueSimpleSuggest from 'vue-simple-suggest';
import { required, requiredUnless, requiredIf, helpers } from 'vuelidate/lib/validators';
import moment from 'moment';

import { FIELDS as REQUIREMENT_FIELDS } from '@/pages/Requirements/constants';
import { FIELDS as INVENTORY_FIELDS } from '@/pages/Inventory/components/InventoryDetails/constants';

import { CRFQ_PART_STATUSES } from '@/pages/Requirements/constants';

import { DATE_FORMAT, AUTO_COMPLETE_STYLES, LEAD_FREE_VALUES, US_DOLLARS_CURRENCY_ID } from '@/shared/constants';

import FormElWrap from '@/shared/components/FormElWrap/index';
import PartForm from '@/pages/Parts/components/PartForm';
const warrantyDeliveryGreaterZero = function(val) { return this.isRequiredWarrantyLeadTime ? val > 0 : true }

export default {
  components: {
    VueSimpleSuggest,
    FormElWrap,
    PartForm,
  },
  props: {
    crfqLineId: [Number, String],
    requirementId: [Number, String],
    addSources: [Boolean],
    pageName: [String],
    backgroundColor: [String],
    lineObj: {
      type: Object,
      default: () => ({}),
    },
    receiveItemDetail: {
      type: Boolean,
      default: false,
    },
    isByPartNumber: {
      type: Boolean,
      default: true,
    },
    invoiceView: {
      type: Boolean,
      default: false
    },
    editableLeadTime: {
      type: Boolean,
      default: false
    },
    onPurchase: {
      type: Boolean,
      default: false
    },
    showMaxQty: {
      type: Boolean,
      default: false
    },
    invoiceLineView: { // hides Needs By, Testing, and Lead Time fields
      type: Boolean,
      default: false
    },
    isRequiredWarrantyLeadTime: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      part: {},
      line: {},
      header: {},
      requirementLine: {},
      reqFields: REQUIREMENT_FIELDS,
      invFields: INVENTORY_FIELDS,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
        /*widgetPositioning: {
          vertical: 'auto'
        }*/
      },
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      testings: [
        { name: 'Yes', value: true },
        { name: 'No', value: false },
      ],
      selectedPart: {},
      chosenPartNumber: null,
      leadFreeValues: LEAD_FREE_VALUES,
      partNumberSelected: false,
      havePart: false,
      isLoadingPart: false,
    }
  },
  computed: {
    ...mapState('requirementAdd', [
      'requirementLines',
    ]),
    ...mapGetters('requirementAdd', [
      'currentRequirementLine',
      'currentPart',
      'partNumbers',
    ]),
    ...mapGetters('lookup', [
      'manufacturers',
      'currencies',
      'conditions',
      'packaging',
      'classes',
      'categories',
      'countryCodes',
      'shipViaList',
      'uoms',
      'warranty'
    ]),
    ...mapGetters('quoteDetails', ['quoteById']),
    // ...mapState('address', [
    //   ,
    // ]),
    convertedPrice() {
      //The converted price is the unit price based on the entered price times the exchange rate
      let qty = this.line[this.reqFields.QUANTITY] || 0;
      let price = this.line[this.reqFields.PRICE] || 0;
      let exchangeRate = this.header[this.reqFields.EXCHANGE_RATE] || 1;

      return price * exchangeRate;
    },
    partId() {
      return this.part ? this.part.id : 0;
    },
    lineTotal() {
      return (this.line[this.reqFields.QUANTITY] * this.line[this.reqFields.PRICE]) * this.header[this.reqFields.EXCHANGE_RATE];
    }
  },
  methods: {
    ...mapActions('requirementAdd', [
      'getRequirementLines',
      'getShipViaList',
      'getPartNumbers',
      'getPartById',
    ]),
    formatMoney(val, digitsToFix = 2) {
      try {
        // var str = Number(val).toFixed(2).toString().split('.');
        // if (str[0].length >= 3) {
        //   str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        // }
        // if (str[1]) {
        //   if (str[1].length < 2) {
        //     while (str[1].length < 2) { str[1] = str[1] + "0"; }
        //   } else if (str[1].length > 2) {
        //     str[1] = str[1].substring(0, 2)
        //   }
        // }
        // return str.join('.');
        var str = Number(val).toFixed(digitsToFix).toString().split('.');
        if (str[0].length >= 3) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1]) {
          if (str[1].length < digitsToFix) {
            while (str[1].length < digitsToFix) { str[1] = str[1] + "0"; }
          } else if (str[1].length > digitsToFix) {
            str[1] = str[1].substring(0, digitsToFix)
          }
        }
        return str.join('.');

      } catch {
        return val;
      }
    },
    async getList(partNumber) {
      await this.getPartNumbers(partNumber);

      return this.partNumbers;
    },
    async onSuggestSelect(suggestion) {
      console.log('Part Number Selected');
      this.selectedPart = suggestion;
      console.log('Selected Part Number: ' + this.selectedPart);
      this.partNumberSelected = true;

      await this.getPartById(suggestion.id);
      this.$emit('onSuggestSelect', suggestion);
      //this.$refs.customerPNInput.focus;
    },
    async onSuggestChange() {
      this.isLoadingPart = true;
      this.$v.chosenPartNumber.$touch();
      if (this.selectedPart.partNumber && this.chosenPartNumber !== this.selectedPart.partNumber) {
        this.part = { id: 0 };
      }
    },
    async onPartNumberBlur() {
      if(this.chosenPartNumber) {
        if (this.partNumbers.length > 0) {
          const findIndex = this.partNumbers.findIndex(x => this.chosenPartNumber.toLowerCase() == x.partNumber.toLowerCase());

          if (findIndex > -1) {
            this.onSuggestSelect(this.partNumbers[findIndex]);
          } else {
            this.partNotFoundConfirmation();
          }
        } else {
          this.partNotFoundConfirmation();
        }
      }
    },
    async partNotFoundConfirmation() {
      const deleteConfirmed = await this.openConfirmBox({
          message: `${this.chosenPartNumber} is not in the database. Press Continue to add them.`,
          okTitle: 'Continue',
        });
        if (deleteConfirmed) {
          this.part = {
            id: 0,
            partNumber: this.chosenPartNumber
          };
          this.$bvModal.show('part-maintenance-model');
        }
    },

    onRequestDone() {
      this.isLoadingPart = false;
    },
    onValueChangePart({ name, value }) {
      this.part = {
        ...this.part,
        [name]: value,
      };
    },
    onValueChangeLine({ name, value }) {
      this.line = {
        ...this.line,
        [name]: value,
      };
    },
    onValueChangeHeader({ name, value }) {
      this.header = {
        ...this.header,
        [name]: value,
      }
    },
    async onPartBlur(){
      if(this.chosenPartNumber && !this.part.id) {

      }
      // $v.chosenPartNumber.$touch();
    },
    async onPartModelClose() {
      this.$bvModal.hide('part-maintenance-model');
    },
    async onPartCreated(e) {
      console.log('onPartCreated: ' + e);

      this.$bvModal.hide('part-maintenance-model');
      this.part = {
        ...e,
        partComments: e.comments,
        cost: e.cost || 0
      };
      this.chosenPartNumber = e.partNumber;
      //await this.getPartById(e.id);
      this.partNumberSelected = true;
      this.line[this.reqFields.PART_ID] = this.part.id;
    },
    async onPartUpdated(e) {
      console.log('onPartUpdated: ' + e);

      this.$bvModal.hide('part-maintenance-model');
      this.part = {
        ...e,
        partComments: e.comments,
        cost: e.cost || 0
      };
      this.chosenPartNumber = e.partNumber;
      //await this.getPartById(e.id);
      this.partNumberSelected = true;
      this.line[this.reqFields.PART_ID] = this.part.id;
    },
    setObjectsExistingLine() {
      if(this.addSources) {
        this.requirementLine = {
          ...this.requirementLine,
          ...this.currentPart,
          [this.reqFields.PART_COMMENTS]: '',
        };

        this.requirementLine[this.reqFields.PART_COMMENTS] = this.requirementLine[this.reqFields.COMMENTS];
        this.requirementLine[this.reqFields.COMMENTS] = '';

        if(this.pageName === 'quotes') {
          const quote = this.quoteById(this.$route.params.id);

          this.requirementLine[this.reqFields.EXCHANGE_RATE] = quote[this.reqFields.EXCHANGE_RATE];
          this.requirementLine[this.reqFields.CURRENCY_TYPE_ID] = quote.currencyId;
        }
      } else {
        console.log('going in here', this.lineObj, this.selectedPart);

        if(Object.keys(this.lineObj).length > 0) { //If line object prop used
          this.requirementLine = { ...this.lineObj };
        } else if(Object.keys(this.selectedPart).length === 0) {
          this.requirementLine = this.currentRequirementLine(this.crfqLineId);
        } else {
          this.requirementLine = this.selectedPart;
        }
      }
      console.log(this.requirementLine, 'REquirement Lien')
      this.chosenPartNumber = this.requirementLine.partNumber;

      this.part = {
        id: Object.keys(this.selectedPart).length === 0 ? this.requirementLine[this.reqFields.PART_ID] : this.requirementLine[this.reqFields.ID],
        partNumber: this.requirementLine[this.reqFields.PART_NUMBER],
        manufacturerId: this.requirementLine[this.reqFields.MANUFACTURER_ID],
        inventoryClassId: this.requirementLine[this.reqFields.CLASS_ID] || this.requirementLine.inventoryClassId,
        inventoryCategoryId: this.requirementLine[this.reqFields.CATEGORY_ID] || this.requirementLine.inventoryCategoryId,
        packageId: this.requirementLine[this.reqFields.PACKAGE_ID],
        piecePerPkg: this.requirementLine[this.reqFields.SPQ],
        physPkg: this.requirementLine[this.reqFields.PHYS_PKG],
        uoMId: this.requirementLine[this.reqFields.UOM_ID],
        tempRating: this.requirementLine[this.reqFields.TEMP_RATING],
        leadFree: this.requirementLine[this.reqFields.LEAD_FREE],
        partComments: this.requirementLine[this.reqFields.PART_COMMENTS],
        nsnNumber: this.requirementLine[this.reqFields.NSN_NUMBER],
        harmonizedCode: this.requirementLine[this.reqFields.HARMONIZED_CODE],
        altNumber: this.requirementLine[this.reqFields.ALT_NUMBER],
        description: this.requirementLine[this.reqFields.DESCRIPTION],
        scheduleB: this.requirementLine[this.reqFields.SCHEDULE_B],
        eccn: this.requirementLine[this.reqFields.ECCN],
        active: true,
      };

      this.line = {
        ...this.line,
        id: Object.keys(this.selectedPart).length === 0 ? this.requirementLine[this.reqFields.ID] : 0,
        lineNum: this.requirementLine.lineNum ? this.requirementLine.lineNum : 0,
        requirementId: this.requirementLine[this.reqFields.REQUIREMENT_ID],
        partId: Object.keys(this.selectedPart).length === 0 ? this.requirementLine[this.reqFields.PART_ID] : this.requirementLine[this.reqFields.ID],
        conditionId: this.requirementLine[this.reqFields.CONDITION_ID],
        quantity: this.requirementLine[this.reqFields.QUANTITY],
        customerPN: this.requirementLine[this.reqFields.CUSTOMER_PN],
        dateCode: this.requirementLine[this.reqFields.DATE_CODE],
        lotCode: this.requirementLine[this.reqFields.LOT_CODE],
        revision: this.requirementLine[this.reqFields.REVISION],
        cost: this.requirementLine[this.reqFields.COST],
        price: this.requirementLine[this.reqFields.PRICE],
        convertedPrice: this.convertedPrice,
        buyPrice: this.requirementLine[this.reqFields.BUY_PRICE],
        vendorNote: this.requirementLine[this.reqFields.VENDOR_NOTE],
        comments: this.requirementLine[this.reqFields.COMMENTS],
        needByDate: (this.requirementLine[this.reqFields.NEED_BY_DATE]) ? moment(this.requirementLine[this.reqFields.NEED_BY_DATE]).format(DATE_FORMAT) : null,
        testingRequested: this.requirementLine[this.reqFields.TESTING_REQUESTED],
        shippingMethodId: this.requirementLine[this.reqFields.SHIPPING_METHOD_ID],
        active: true,
        statusId: this.requirementLine.statusId || this.line.statusId,
        countryOfOriginId: this.requirementLine.countryOfOriginId,
        purchaseOrderId: this.requirementLine.purchaseOrderId,
        purchaseOrderLineId: this.requirementLine.id,
        salesOrderLineId: this.requirementLine.salesOrderLineId,
        requirementLineId: this.requirementLine.requirementLineId,
        quoteLineId: this.requirementLine.quoteLineId,
        total: this.requirementLine[this.reqFields.TOTAL],
        leadTime: this.requirementLine[this.reqFields.LEAD_TIME],
        currencySymbol: this.requirementLine.currencySymbol,
        warrantyId: this.requirementLine[this.reqFields.WARRANTY_ID],
        vendorWarrantyId: this.requirementLine[this.reqFields.VENDOR_WARRANTY_ID],
        customerDelivery: this.requirementLine[this.reqFields.CUSTOMER_DELIVERY],
        vendorDelivery: this.requirementLine[this.reqFields.VENDOR_DELIVERY],
        moq: this.requirementLine[this.reqFields.MOQ],
        maxQuantity: this.requirementLine.maxQuantity,
        isInStock: this.requirementLine.isInStock || null,
        isFullLabelTraceable: this.requirementLine.isFullLabelTraceable  || null,
        isLotCodeRemoved: this.requirementLine.isLotCodeRemoved || null,
        isMfrCocPackList: this.requirementLine.isMfrCocPackList || null,
        isFranchiseCocPackList: this.requirementLine.isFranchiseCocPackList || null,
        isNotTraceable: this.requirementLine.isNotTraceable || null
      };

      this.header = {
        currencyTypeId: this.requirementLine[this.reqFields.CURRENCY_TYPE_ID] || 1,
        exchangeRate: this.requirementLine[this.reqFields.EXCHANGE_RATE] || 1,
        active: true,
      };
    },
    clearForm() {
      this.part = {};
      this.line = {};
      this.header = {
        exchangeRate: 1,
        currencyTypeId: 1,
        active: true,
      };
      this.chosenPartNumber = '';
      this.selectedPart = {};
      this.partNumberSelected = false;
    },
    getLineValidation() {
      this.$v.$touch();
      this.$emit('line-validation', this.$v.$invalid);
    }
  },
  watch: {
    part: {
      handler() {
        this.$emit('partChange', this.part);
      },
      deep: true,
    },
    line: {
      handler() {
        if(this.onPurchase){
        this.line.cost = 0;
        }
        this.$emit('lineChange', this.line);

      },
      deep: true,
    },
    header: {
      handler() {
        this.$emit('headerChange', this.header);
      },
      deep: true,
    },
    chosenPartNumber() {
      if (this.part) {
        this.part.partNumber = this.chosenPartNumber;
      }
    },
    currentPart() {
      this.setObjectsExistingLine();
    },
    requirementLines() {
      this.setObjectsExistingLine();
    },
    lineObj() {
      console.log('calling lineObj watcher');

      this.setObjectsExistingLine();
    },
    convertedPrice() {
      this.line.convertedPrice = this.convertedPrice;
    }
  },
  async created() {
    if(this.addSources || Object.keys(this.lineObj).length > 0) {
      this.partNumberSelected = true;
    }

    if(Object.keys(this.lineObj).length > 0) { //If line object prop used
      //this.requirementLine = { ...this.lineObj };

      await this.setObjectsExistingLine();
    } else if(this.requirementId && !this.crfqLineId) { //If already added requirement, but no line
      this.line = {
        id: 0,
        requirementId: this.requirementId,
        statusId: 133,
        active: true,
      };

      this.part = {
        id: 0,
        partNumber: '',
        active: true,
      };

      this.header = {
        exchangeRate: 1,
        currencyTypeId: 1,
        active: true,
      };
    } else if(this.requirementId && this.crfqLineId) { //If already addded requirement line, so edit
      //If hasn't received Vuex data yet TODO: figure out how to prevent need for duplicated AJAX call
      if(!this.requirementLines) await this.getRequirementLines(this.requirementId);

      await this.setObjectsExistingLine();
    } else {
      this.line = {
        id: 0,
        requirementId: 0,
        statusId: 133,
        partId: 0,
        active: true,
      };

      this.part = {
        id: 0,
        partNumber: '',
        active: true,
      };

      this.header = {
        exchangeRate: 1,
        currencyTypeId: 1,
        active: true,
      };
    }
  },
  validations: {
    chosenPartNumber: { required },
    line: {
      [REQUIREMENT_FIELDS.QUANTITY]: { required },
      [REQUIREMENT_FIELDS.PRICE]: { required },
      [REQUIREMENT_FIELDS.DATE_CODE]: { required },
      [REQUIREMENT_FIELDS.WARRANTY_ID]: { required: requiredIf(function(){ return !this.onPurchase && this.isRequiredWarrantyLeadTime }), warrantyDeliveryGreaterZero },
      [REQUIREMENT_FIELDS.CUSTOMER_DELIVERY]: { required: requiredIf(function(){ return !this.onPurchase && !this.invoiceLineView && this.isRequiredWarrantyLeadTime }) },
      [REQUIREMENT_FIELDS.SHIPPING_METHOD_ID]: { required },
      
    },
  },
}

</script>

<style lang="scss">
.part-lookup {
  &--plus {
    font-size: 10px;
  }
}
#part-maintenance-model .modal-dialog {
  max-width: 1550px !important;
}

.bootstrap-datetimepicker-widget{
  top:auto !important;
  bottom:20px !important;
}
</style>